import NextImage from "next/image";
import type { ImageProps as NextImageProps } from "next/image";
import type { CSSProperties } from "react";

export interface ImageProps {
  src: NextImageProps["src"];
  alt?: string;
  width: number;
  height: number;
  loadingMethod?: "eager" | "lazy";
  sx?: CSSProperties;
  fetchPriority?: "high" | "low" | "auto";
  priority?: boolean;
}

export function Image({
  src,
  alt = "",
  width,
  height,
  loadingMethod = "eager",
  sx,
  fetchPriority = "high",
  priority = false,
}: ImageProps) {
  return (
    <NextImage
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading={loadingMethod}
      quality={100}
      style={sx}
      fetchPriority={fetchPriority}
      priority={priority}
    />
  );
}
